const FAQ_PLAY = [
  {
    title: 'Quais são as formas de pagamento? É seguro?',
    content:
      'Sim, é seguro! Os pagamentos são feitos pela Hotmart, uma das maiores plataformas de pagamento online do Brasil. Você pode pagar com cartão de crédito, boleto bancário, PIX ou PayPal, de acordo com as opções disponíveis no momento da compra. O pagamento de forma parcelada só é possível via cartão de crédito'
  },
  {
    title: 'O que é o plano Play',
    content: (
      <>
        O Foguete Play é para você que quer apenas treinar com o conteúdo
        gravado e atualizado mensalmente.
      </>
    )
  },
  {
    title: 'Após assinar, terei acesso por quanto tempo? Existe fidelidade?',
    content: (
      <>
        A Academia Foguete funciona no modelo de assinatura com renovação
        automática pela Hotmart, sempre na mesma data em que você fez a compra.{' '}
        <br />
        <br />
        Você pode escolher entre os planos trimestral, semestral ou anual:
        <ul>
          <li style={{ listStyle: 'disc', marginLeft: '24px' }}>
            <strong>Planos trimestral, semestral e anual:</strong> têm
            fidelidade, mas oferecem mais economia e o acesso continua
            normalmente enquanto os pagamentos estiverem em dia.
          </li>
        </ul>
        <br />
        Fique tranquila(o), todas as informações ficam disponíveis no momento da
        compra e você pode gerenciar sua assinatura com facilidade pela própria
        Hotmart.
      </>
    )
  },
  {
    title: 'Como funciona o cancelamento até o 7º dia?',
    content: (
      <>
        Você tem até <strong>7 dias corridos</strong> após a data da compra para
        solicitar o cancelamento com reembolso total, conforme previsto no{' '}
        <strong>Código de Defesa do Consumidor</strong>.
        <br />
        <br />
        É só entrar em contato com o nosso time de suporte dentro desse prazo
        que a gente resolve tudo rapidinho!
        <br />
        <br />
        Se preferir, você também pode fazer o cancelamento diretamente pela sua
        conta na Hotmart.
      </>
    )
  },
  {
    title: 'Os treinos são apenas para casa?',
    content: (
      <>
        Nada disso! Você pode treinar onde quiser: em casa, na academia, no
        quintal, no parque... As aulas foram pensadas para se adaptar à sua
        rotina, ao seu espaço e ao seu objetivo. <br />
        <br />É treino com liberdade, do seu jeito!
      </>
    )
  },
  {
    title: 'A Academia Foguete funciona pelo celular?',
    content:
      'Sim! Você consegue acessar tanto os treinos gravados quanto os ao vivo direto do celular, computador ou tablet. Você precisará de uma boa conexão com a internet, tudo é pensado para ser bem prático e adaptado para sua rotina.'
  },
  {
    title: 'Serve para todos os níveis?',
    content:
      'Sim! Os treinos são pensados para todos os níveis – iniciante, intermediário ou avançado. É só escolher o tipo de treino de acordo com seu nível e que mais te agrada e suar a camisa 🙂'
  },
  {
    title: 'Os treinos são só para mulheres ou homens também podem fazer?',
    content: (
      <>
        Nada disso! Os treinos da Academia Foguete são feitos para todos os
        públicos, sem nenhuma restrição de gênero.
        <br />
        <br />
        Independente do seu objetivo —{' '}
        <strong>
          emagrecimento, ganho de massa ou só manter a saúde em dia
        </strong>{' '}
        — nossos vídeos de introdução explicam direitinho como adaptar cada
        exercício conforme sua meta e nível.
      </>
    )
  },
  {
    title: 'Os treinos são para emagrecer ou crescer?',
    content:
      'Você pode usar os treinos tanto para emagrecer quanto para ganhar massa muscular, dependendo do seu objetivo e da sua alimentação. A plataforma tem uma variedade enorme de estilos de treino para te ajudar nesse processo.'
  },
  {
    title: 'Como funciona a divisão dos treinos?',
    content: (
      <>
        Na nossa plataforma, você encontra um módulo exclusivo que te ajuda a
        identificar seu nível de treino — seja{' '}
        <strong>iniciante, intermediário ou avançado.</strong>
        <br />
        <br />É só seguir as orientações por lá 😉 E se pintar qualquer dúvida
        no caminho, nosso canal de suporte está pronto pra te ajudar com tudo
        que precisar!
      </>
    )
  },
  {
    title: 'É obrigatório o uso de Equipamento/Peso?',
    content: (
      <>
        Não! Os treinos do <strong>método LapaTeam</strong>, por exemplo, são
        pensados para usar apenas o peso do próprio corpo — então você consegue
        treinar sem nenhum equipamento, de forma prática e eficiente.
        <br />
        <br />
        Mas se o seu objetivo for{' '}
        <strong>hipertrofia (ganho de massa muscular)</strong>, aí sim é
        importante ter pesos ou equipamentos que ajudem a intensificar o treino,
        como halteres, caneleiras, elásticos ou o que você tiver disponível em
        casa.
      </>
    )
  },
  {
    title: 'Os treinos são atualizados?',
    content:
      'Sim! O conteúdo da plataforma é atualizado todos os meses com novos treinos gravados, além das aulas ao vivo que acontecem diariamente.'
  },
  {
    title: 'O que são os Guias Nutricionais disponíveis na plataforma?',
    content:
      'São materiais complementares com informações e sugestões práticas de alimentação, organizados por nutricionistas parceiros. Eles ajudam a alinhar sua dieta com seus objetivos de treino.'
  },
  {
    title: 'Preciso deixar a câmera ligada no ao vivo?',
    content: (
      <>
        Não precisa! A câmera é totalmente opcional — você escolhe se quer ligar
        ou não.
        <br />
        Mas deixar a câmera ligada pode ser uma ótima ideia: assim, o professor
        consegue te ver durante o treino, corrigir movimentos e te ajudar ao
        vivo, deixando a aula mais segura e personalizada.
        <br />
        <br />
        Você faz do seu jeito, no seu tempo!
      </>
    )
  },
  {
    title: 'Eu consigo espelhar os treinos na TV?',
    content: (
      <>
        Sim! É possível espelhar os treinos diretamente do seu celular ou
        computador para a TV, desde que ambos os dispositivos estejam conectados
        à mesma rede Wi-Fi. O recurso funciona com Smart TVs compatíveis.
        <br />
        <a
          href="https://www.instagram.com/reel/CyL0rMYuCm8/"
          target="_blank"
          style={{ color: '#FFF', textDecoration: 'underline' }}
        >
          Temos um vídeo explicativo no nosso Instagram que mostra o passo a
          passo:
        </a>
      </>
    )
  },
  {
    title: 'A renovação do plano é automática?',
    content: (
      <>
        <strong>
          Sim! A renovação do plano acontece automaticamente, como informado nos
          termos no momento da adesão.
        </strong>
        <br />
        A Hotmart, nossa plataforma de pagamento, envia um e-mail avisando sobre
        a renovação com alguns dias de antecedência, usando o e-mail que você
        cadastrou na hora da compra.
        <br />
        <br />
        Por isso, vale sempre dar uma olhadinha na sua caixa de entrada.
      </>
    )
  }
]

const FAQ_LIVE = [
  {
    title: 'Quais são as formas de pagamento? É seguro?',
    content:
      'Sim, é seguro! Os pagamentos são feitos pela Hotmart, uma das maiores plataformas de pagamento online do Brasil. Você pode pagar com cartão de crédito, boleto bancário, PIX ou PayPal, de acordo com as opções disponíveis no momento da compra. O pagamento de forma parcelada só é possível via cartão de crédito'
  },
  {
    title: 'O que é o Plano Play+Ao Vivo?',
    content: (
      <>
        O Foguete Play+Ao Vivo é a experiência completa da Academia Online
        Foguete. Você vai ter acesso a todos os treinos online e ao vivo no
        Zoom. E, também, a todos os conteúdos gravados de treino.
      </>
    )
  },
  {
    title: 'Após assinar, terei acesso por quanto tempo? Existe fidelidade?',
    content: (
      <>
        A Academia Foguete funciona no modelo de assinatura com renovação
        automática pela Hotmart, sempre na mesma data em que você fez a compra.{' '}
        <br />
        <br />
        Você pode escolher entre os planos trimestral, semestral ou anual:
        <ul>
          <li style={{ listStyle: 'disc', marginLeft: '24px' }}>
            <strong>Planos trimestral, semestral e anual:</strong> têm
            fidelidade, mas oferecem mais economia e o acesso continua
            normalmente enquanto os pagamentos estiverem em dia.
          </li>
        </ul>
        <br />
        Fique tranquila(o), todas as informações ficam disponíveis no momento da
        compra e você pode gerenciar sua assinatura com facilidade pela própria
        Hotmart.
      </>
    )
  },
  {
    title: 'Como funciona o cancelamento até o 7º dia?',
    content: (
      <>
        Você tem até <strong>7 dias corridos</strong> após a data da compra para
        solicitar o cancelamento com reembolso total, conforme previsto no{' '}
        <strong>Código de Defesa do Consumidor</strong>.
        <br />
        <br />
        É só entrar em contato com o nosso time de suporte dentro desse prazo
        que a gente resolve tudo rapidinho!
        <br />
        <br />
        Se preferir, você também pode fazer o cancelamento diretamente pela sua
        conta na Hotmart.
      </>
    )
  },
  {
    title: 'Os treinos são apenas para casa?',
    content: (
      <>
        Nada disso! Você pode treinar onde quiser: em casa, na academia, no
        quintal, no parque... As aulas foram pensadas para se adaptar à sua
        rotina, ao seu espaço e ao seu objetivo. <br />
        <br />É treino com liberdade, do seu jeito!
      </>
    )
  },
  {
    title: 'A Academia Foguete funciona pelo celular?',
    content:
      'Sim! Você consegue acessar tanto os treinos gravados quanto os ao vivo direto do celular, computador ou tablet. Você precisará de uma boa conexão com a internet, tudo é pensado para ser bem prático e adaptado para sua rotina.'
  },
  {
    title: 'Como funcionam os treinos ao vivo? As aulas ficarão gravadas?',
    content: (
      <>
        Nossos treinos ao vivo são um verdadeiro show de energia e cuidado,
        liderados pelo incrível <strong>personal Ricardo Lapa</strong> e um{' '}
        <strong>time de professores apaixonados pelo que fazem.</strong> As
        aulas acontecem pelo Zoom, em formato coletivo, onde todos se veem —
        assim, os professores conseguem corrigir os movimentos em tempo real,
        deixando a experiência mais personalizada, segura e divertida!
        <br />
        <br />E se sua rotina for corrida, não tem problema! A plataforma também
        oferece uma biblioteca com{' '}
        <strong>treinos gravados disponíveis 24 horas por dia</strong>, para
        você se movimentar onde e quando quiser. A gente faz questão de te
        acompanhar em qualquer momento do seu dia.
      </>
    )
  },
  {
    title: 'Serve para todos os níveis?',
    content:
      'Sim! Os treinos são pensados para todos os níveis – iniciante, intermediário ou avançado. É só escolher o tipo de treino de acordo com seu nível e que mais te agrada e suar a camisa 🙂'
  },
  {
    title: 'Os treinos são só para mulheres ou homens também podem fazer?',
    content: (
      <>
        Nada disso! Os treinos da Academia Foguete são feitos para todos os
        públicos, sem nenhuma restrição de gênero.
        <br />
        <br />
        Independente do seu objetivo —{' '}
        <strong>
          emagrecimento, ganho de massa ou só manter a saúde em dia
        </strong>{' '}
        — nossos vídeos de introdução explicam direitinho como adaptar cada
        exercício conforme sua meta e nível.
      </>
    )
  },
  {
    title: 'Os treinos são para emagrecer ou crescer?',
    content:
      'Você pode usar os treinos tanto para emagrecer quanto para ganhar massa muscular, dependendo do seu objetivo e da sua alimentação. A plataforma tem uma variedade enorme de estilos de treino para te ajudar nesse processo.'
  },
  {
    title: 'Como funciona a divisão dos treinos?',
    content: (
      <>
        Na nossa plataforma, você encontra um módulo exclusivo que te ajuda a
        identificar seu nível de treino — seja{' '}
        <strong>iniciante, intermediário ou avançado.</strong>
        <br />
        <br />É só seguir as orientações por lá 😉 E se pintar qualquer dúvida
        no caminho, nosso canal de suporte está pronto pra te ajudar com tudo
        que precisar!
      </>
    )
  },
  {
    title: 'É obrigatório o uso de Equipamento/Peso?',
    content: (
      <>
        Não! Os treinos do <strong>método LapaTeam</strong>, por exemplo, são
        pensados para usar apenas o peso do próprio corpo — então você consegue
        treinar sem nenhum equipamento, de forma prática e eficiente.
        <br />
        <br />
        Mas se o seu objetivo for{' '}
        <strong>hipertrofia (ganho de massa muscular)</strong>, aí sim é
        importante ter pesos ou equipamentos que ajudem a intensificar o treino,
        como halteres, caneleiras, elásticos ou o que você tiver disponível em
        casa.
      </>
    )
  },
  {
    title: 'Os treinos são atualizados?',
    content:
      'Sim! O conteúdo da plataforma é atualizado todos os meses com novos treinos gravados, além das aulas ao vivo que acontecem diariamente.'
  },
  {
    title: 'O que são os Guias Nutricionais disponíveis na plataforma?',
    content:
      'São materiais complementares com informações e sugestões práticas de alimentação, organizados por nutricionistas parceiros. Eles ajudam a alinhar sua dieta com seus objetivos de treino.'
  },
  {
    title: 'Preciso deixar a câmera ligada no ao vivo?',
    content: (
      <>
        Não precisa! A câmera é totalmente opcional — você escolhe se quer ligar
        ou não.
        <br />
        Mas deixar a câmera ligada pode ser uma ótima ideia: assim, o professor
        consegue te ver durante o treino, corrigir movimentos e te ajudar ao
        vivo, deixando a aula mais segura e personalizada.
        <br />
        <br />
        Você faz do seu jeito, no seu tempo!
      </>
    )
  },
  {
    title: 'Eu consigo espelhar os treinos na TV?',
    content: (
      <>
        Sim! É possível espelhar os treinos diretamente do seu celular ou
        computador para a TV, desde que ambos os dispositivos estejam conectados
        à mesma rede Wi-Fi. O recurso funciona com Smart TVs compatíveis.
        <br />
        <a
          href="https://www.instagram.com/reel/CyL0rMYuCm8/"
          target="_blank"
          style={{ color: '#FFF', textDecoration: 'underline' }}
        >
          Temos um vídeo explicativo no nosso Instagram que mostra o passo a
          passo:
        </a>
      </>
    )
  },
  {
    title: 'A renovação do plano é automática?',
    content: (
      <>
        <strong>
          Sim! A renovação do plano acontece automaticamente, como informado nos
          termos no momento da adesão.
        </strong>
        <br />
        A Hotmart, nossa plataforma de pagamento, envia um e-mail avisando sobre
        a renovação com alguns dias de antecedência, usando o e-mail que você
        cadastrou na hora da compra.
        <br />
        <br />
        Por isso, vale sempre dar uma olhadinha na sua caixa de entrada.
      </>
    )
  }
]

const FAQ_DEFAULT = [
  {
    title: 'Quais são as formas de pagamento? É seguro?',
    content:
      'Sim, é seguro! Os pagamentos são feitos pela Hotmart, uma das maiores plataformas de pagamento online do Brasil. Você pode pagar com cartão de crédito, boleto bancário, PIX ou PayPal, de acordo com as opções disponíveis no momento da compra. O pagamento de forma parcelada só é possível via cartão de crédito'
  },
  {
    title: 'Qual a diferença entre os planos: Play e Play+Ao Vivo?',
    content: (
      <>
        O Foguete Play é para você que quer apenas treinar com um conteúdo super
        completo, gravado e atualizado mensalmente.
        <br />
        <br />
        Já o Foguete Play + Ao Vivo é uma experiência completa: você terá acesso
        tanto aos treinos online ao vivo pelo Zoom quanto a todos os conteúdos
        gravados da plataforma.
      </>
    )
  },
  {
    title: 'Após assinar, terei acesso por quanto tempo? Existe fidelidade?',
    content: (
      <>
        A Academia Foguete funciona no modelo de assinatura com renovação
        automática pela Hotmart, sempre na mesma data em que você fez a compra.{' '}
        <br />
        <br />
        Você pode escolher entre os planos trimestral, semestral ou anual:
        <ul>
          <li style={{ listStyle: 'disc', marginLeft: '24px' }}>
            <strong>Planos trimestral, semestral e anual:</strong> têm
            fidelidade, mas oferecem mais economia e o acesso continua
            normalmente enquanto os pagamentos estiverem em dia.
          </li>
        </ul>
        <br />
        Fique tranquila(o), todas as informações ficam disponíveis no momento da
        compra e você pode gerenciar sua assinatura com facilidade pela própria
        Hotmart.
      </>
    )
  },
  {
    title: 'Como funciona o cancelamento até o 7º dia?',
    content: (
      <>
        Você tem até <strong>7 dias corridos</strong> após a data da compra para
        solicitar o cancelamento com reembolso total, conforme previsto no{' '}
        <strong>Código de Defesa do Consumidor</strong>.
        <br />
        <br />
        É só entrar em contato com o nosso time de suporte dentro desse prazo
        que a gente resolve tudo rapidinho!
        <br />
        <br />
        Se preferir, você também pode fazer o cancelamento diretamente pela sua
        conta na Hotmart.
      </>
    )
  },
  {
    title: 'Os treinos são apenas para casa?',
    content: (
      <>
        Nada disso! Você pode treinar onde quiser: em casa, na academia, no
        quintal, no parque... As aulas foram pensadas para se adaptar à sua
        rotina, ao seu espaço e ao seu objetivo. <br />
        <br />É treino com liberdade, do seu jeito!
      </>
    )
  },
  {
    title: 'A Academia Foguete funciona pelo celular?',
    content:
      'Sim! Você consegue acessar tanto os treinos gravados quanto os ao vivo direto do celular, computador ou tablet. Você precisará de uma boa conexão com a internet, tudo é pensado para ser bem prático e adaptado para sua rotina.'
  },
  {
    title: 'Como funcionam os treinos ao vivo? As aulas ficarão gravadas?',
    content: (
      <>
        Nossos treinos ao vivo são um verdadeiro show de energia e cuidado,
        liderados pelo incrível <strong>personal Ricardo Lapa</strong> e um{' '}
        <strong>time de professores apaixonados pelo que fazem.</strong> As
        aulas acontecem pelo Zoom, em formato coletivo, onde todos se veem —
        assim, os professores conseguem corrigir os movimentos em tempo real,
        deixando a experiência mais personalizada, segura e divertida!
        <br />
        <br />E se sua rotina for corrida, não tem problema! A plataforma também
        oferece uma biblioteca com{' '}
        <strong>treinos gravados disponíveis 24 horas por dia</strong>, para
        você se movimentar onde e quando quiser. A gente faz questão de te
        acompanhar em qualquer momento do seu dia.
      </>
    )
  },
  {
    title: 'Serve para todos os níveis?',
    content:
      'Sim! Os treinos são pensados para todos os níveis – iniciante, intermediário ou avançado. É só escolher o tipo de treino de acordo com seu nível e que mais te agrada e suar a camisa 🙂'
  },
  {
    title: 'Os treinos são só para mulheres ou homens também podem fazer?',
    content: (
      <>
        Nada disso! Os treinos da Academia Foguete são feitos para todos os
        públicos, sem nenhuma restrição de gênero.
        <br />
        <br />
        Independente do seu objetivo —{' '}
        <strong>
          emagrecimento, ganho de massa ou só manter a saúde em dia
        </strong>{' '}
        — nossos vídeos de introdução explicam direitinho como adaptar cada
        exercício conforme sua meta e nível.
      </>
    )
  },
  {
    title: 'Os treinos são para emagrecer ou crescer?',
    content:
      'Você pode usar os treinos tanto para emagrecer quanto para ganhar massa muscular, dependendo do seu objetivo e da sua alimentação. A plataforma tem uma variedade enorme de estilos de treino para te ajudar nesse processo.'
  },
  {
    title: 'Como funciona a divisão dos treinos?',
    content: (
      <>
        Na nossa plataforma, você encontra um módulo exclusivo que te ajuda a
        identificar seu nível de treino — seja{' '}
        <strong>iniciante, intermediário ou avançado.</strong>
        <br />
        <br />É só seguir as orientações por lá 😉 E se pintar qualquer dúvida
        no caminho, nosso canal de suporte está pronto pra te ajudar com tudo
        que precisar!
      </>
    )
  },
  {
    title: 'É obrigatório o uso de Equipamento/Peso?',
    content: (
      <>
        Não! Os treinos do <strong>método LapaTeam</strong>, por exemplo, são
        pensados para usar apenas o peso do próprio corpo — então você consegue
        treinar sem nenhum equipamento, de forma prática e eficiente.
        <br />
        <br />
        Mas se o seu objetivo for{' '}
        <strong>hipertrofia (ganho de massa muscular)</strong>, aí sim é
        importante ter pesos ou equipamentos que ajudem a intensificar o treino,
        como halteres, caneleiras, elásticos ou o que você tiver disponível em
        casa.
      </>
    )
  },
  {
    title: 'Os treinos são atualizados?',
    content:
      'Sim! O conteúdo da plataforma é atualizado todos os meses com novos treinos gravados, além das aulas ao vivo que acontecem diariamente.'
  },
  {
    title: 'O que são os Guias Nutricionais disponíveis na plataforma?',
    content:
      'São materiais complementares com informações e sugestões práticas de alimentação, organizados por nutricionistas parceiros. Eles ajudam a alinhar sua dieta com seus objetivos de treino.'
  },
  {
    title: 'Preciso deixar a câmera ligada no ao vivo?',
    content: (
      <>
        Não precisa! A câmera é totalmente opcional — você escolhe se quer ligar
        ou não.
        <br />
        Mas deixar a câmera ligada pode ser uma ótima ideia: assim, o professor
        consegue te ver durante o treino, corrigir movimentos e te ajudar ao
        vivo, deixando a aula mais segura e personalizada.
        <br />
        <br />
        Você faz do seu jeito, no seu tempo!
      </>
    )
  },
  {
    title: 'Eu consigo espelhar os treinos na TV?',
    content: (
      <>
        Sim! É possível espelhar os treinos diretamente do seu celular ou
        computador para a TV, desde que ambos os dispositivos estejam conectados
        à mesma rede Wi-Fi. O recurso funciona com Smart TVs compatíveis.
        <br />
        <a
          href="https://www.instagram.com/reel/CyL0rMYuCm8/"
          target="_blank"
          style={{ color: '#FFF', textDecoration: 'underline' }}
        >
          Temos um vídeo explicativo no nosso Instagram que mostra o passo a
          passo:
        </a>
      </>
    )
  },
  {
    title: 'A renovação do plano é automática?',
    content: (
      <>
        <strong>
          Sim! A renovação do plano acontece automaticamente, como informado nos
          termos no momento da adesão.
        </strong>
        <br />
        A Hotmart, nossa plataforma de pagamento, envia um e-mail avisando sobre
        a renovação com alguns dias de antecedência, usando o e-mail que você
        cadastrou na hora da compra.
        <br />
        <br />
        Por isso, vale sempre dar uma olhadinha na sua caixa de entrada.
      </>
    )
  }
]

export const FAQ = {
  default: FAQ_DEFAULT,
  live: FAQ_LIVE,
  play: FAQ_PLAY
}
